import React, { useState } from 'react';
import { DropdownItem } from '../common/DropdownItem';
import { Dropdown } from '../common/Dropdown';
import { Link } from 'react-router-dom';
import { FaCog, FaSignOutAlt, FaChevronDown } from 'react-icons/fa';
import { decodeJWT } from '../../utils/jwt';

export default function UserDropdown() {
    const [isOpen, setIsOpen] = useState(false);

    function toggleDropdown() {
        setIsOpen(!isOpen);
    }

    function closeDropdown() {
        setIsOpen(false);
    }

    const accessToken = sessionStorage.getItem('access_token');
    const tokenPayload = decodeJWT(accessToken);

    return (
        <div className='relative'>
            <button onClick={toggleDropdown} className='flex items-center text-gray-700 '>
                <span className='block mr-1 font-medium text-theme-sm'>{tokenPayload?.nickname}</span>
                <FaChevronDown className={`stroke-gray-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>

            <Dropdown isOpen={isOpen} onClose={closeDropdown} className='absolute right-0 mt-[17px] flex w-[260px] flex-col rounded-2xl border border-gray-200 bg-white p-3 shadow-theme-lg'>
                <div>
                    <span className='block font-medium text-gray-700 text-theme-sm'>{tokenPayload?.firstname} {tokenPayload?.lastname}</span>
                    <span className='mt-0.5 block text-theme-xs text-gray-500'>{tokenPayload?.role}</span>
                </div>
                <ul className='flex flex-col gap-1 pt-4 pb-3 border-b border-gray-200'>
                    <li>
                        <DropdownItem onItemClick={closeDropdown} tag='a' href='/account' className='flex items-center gap-3 px-3 py-2 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700'>
                            <FaCog /> Account settings
                        </DropdownItem>
                    </li>
                </ul>

                <Link to='/logout' className='flex items-center gap-3 px-3 py-2 mt-3 font-medium text-gray-700 rounded-lg group text-theme-sm hover:bg-gray-100 hover:text-gray-700'>
                    <FaSignOutAlt /> Uitloggen
                </Link>
            </Dropdown>
        </div>
    );
}
